<template>
  <div class="legal-page">
    <div class="legal-body" v-html="html" />
  </div>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'LegalPage',

  props: {
    content: {
      type: String,
      required: true
    }
  },

  computed: {
    html() {
      return marked.parse(this.content);
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/_variables.scss';

.legal-page {
  max-width: 1200px;
  margin: 0 auto;
  padding: 56px 48px 96px;

  @media (max-width: 600px) {
    padding: 40px 20px 72px;
  }
}

.legal-body {
  ::v-deep {
    h1 {
      font-size: clamp(1.75rem, 3vw, 2.25rem);
      font-weight: 700;
      color: $text-dark;
      margin: 0 0 8px;
      line-height: 1.2;
    }

    h2 {
      font-size: 1.15rem;
      font-weight: 700;
      color: $text-dark;
      margin: 48px 0 16px;
      padding-top: 48px;
      border-top: 1px solid $border;

      &:first-of-type {
        margin-top: 40px;
        padding-top: 40px;
      }
    }

    p {
      font-size: 15px;
      line-height: 1.75;
      color: #444;
      margin: 0 0 16px;

      &:last-child {
        margin-bottom: 0;
      }
    }

    ul {
      margin: 0 0 16px;
      padding-left: 20px;

      li {
        font-size: 15px;
        line-height: 1.75;
        color: #444;
        margin-bottom: 6px;
      }
    }

    strong {
      color: $text-dark;
      font-weight: 600;
    }

    a {
      color: $brand-color;
      text-decoration: none;
      border-bottom: 1px solid currentColor;

      &:hover {
        color: $brand-dark;
      }
    }

    hr {
      border: none;
      border-top: 1px solid $border;
      margin: 0;
    }
  }
}
</style>
